import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services';
import { useAuth } from '../context/AuthContext';
import './Login.css';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await authService.login({ email, password });
      if (!data?.success) {
        setError(data?.message || 'Falha ao entrar');
      } else {
        login(data);
        navigate('/home');
      }
    } catch (requestError) {
      setError('Erro de conexão');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-shell">
        <aside className="login-hero">
          <div className="login-hero-overlay" />
          <div className="login-hero-content">
            <span className="login-hero-tag">Marketing PRO</span>
            <h1>Entre na sua conta</h1>
            <p>Ambiente modular com fluxo de criação e gestão.</p>
          </div>
        </aside>

        <section className="login-panel">
          <header className="login-header">
            <div className="logo-container">
              <img src="/logo-branca.png" alt="Marketing PRO" className="logo-image" />
            </div>
          </header>

          {error && <div className="error-message">{error}</div>}

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="email">E-mail</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <label htmlFor="password">Senha</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </div>
            <button className="btn btn-outline btn-full" type="submit" disabled={loading}>
              <span className="inner">{loading ? 'Entrando...' : 'Entrar'}</span>
            </button>
          </form>

          <footer className="login-footer">
            <div className="signup-link">
              Não tem uma conta? <Link to="/signup">Criar conta</Link>
            </div>
          </footer>
        </section>
      </div>
    </div>
  );
}

export default Login;
